// extracted by mini-css-extract-plugin
export default {"feedPreviewOutputs":"n4cbNinBI2hsMpTpd0Io__feedPreviewOutputs___","header":"QgTHypqMZiUDM_5OCIpS__header___","recordListContainer":"rHjNf8wefYOo6r3GkYE7__recordListContainer___"};